import { Elements } from "@stripe/react-stripe-js";
import { useLocation, useNavigate } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import { useEffect } from "react";
import EventPaymentForm from "./EventPaymentForm";
import "../styles/PaymentPage.scss";

const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
);

export default function EventPaymentPage() {
  const { state } = useLocation();
  const navigate = useNavigate();

  // Mirror calcPrice from EventDetail
  const calcPrice = (section, qty) => {
    if (qty < 1 || !section) return { usedPrice: 0, total: 0, savings: 0 };

    const basePrice = parseFloat(section.price || 0);
    let usedPrice = basePrice;
    let savings = 0;

    if (section.group_prices && Array.isArray(section.group_prices)) {
      const applicable = section.group_prices
        .sort((a, b) => a.min_quantity - b.min_quantity)
        .find(gp => gp.min_quantity === qty);

      if (applicable) {
        usedPrice = parseFloat(applicable.group_price);
        savings = Math.round((basePrice - usedPrice) * qty * 100) / 100;
      }
    }

    const total = Math.round(usedPrice * qty * 100) / 100;

    return { usedPrice, total, savings };
  };

  useEffect(() => {
    if (!state?.clientSecret) {
      navigate("/");
    }
  }, [state, navigate]);

  if (!state?.clientSecret) {
    return null;
  }

  const { event, selectedSection, quantity } = state;
  const priceInfo = calcPrice(selectedSection, quantity);
  const ticketAmount = priceInfo.total;
  const savings = priceInfo.savings;
  const serviceCharge = Number(state.service_charge || 0);
  const stripeFee = Number(state.stripe_fee || 0);
  const total = ticketAmount + serviceCharge;

  return (
    <div className="payment-wrapper">
      <div className="payment-card">
        <h2 className="payment-title">Complete Payment</h2>

        <div className="payment-summary">
          <div className="summary-row">
            <span className="label">Event</span>
            <span className="value">{event?.heading}</span>
          </div>

          <div className="summary-row">
            <span className="label">Section</span>
            <span className="value">{selectedSection?.title}</span>
          </div>

          <div className="summary-row">
            <span className="label">Quantity</span>
            <span className="value">{quantity}</span>
          </div>

          <div className="summary-row">
            <span className="label">Ticket Price</span>
            <span className="value">€ {ticketAmount.toFixed(2)}</span>
          </div>
          {savings > 0 && (
            <div className="summary-row savings-row">
              <span className="label">Savings</span>
              <span className="value">-€ {savings.toFixed(2)}</span>
            </div>
          )}
          <div className="summary-row">
            <span className="label">Service Charge</span>
            <span className="value">€ {serviceCharge.toFixed(2)}</span>
          </div>
          {/* <div className="summary-row">
            <span className="label">Processing Fee(Stripe)</span>
            <span className="value">€ {stripeFee.toFixed(2)}</span>
          </div> */}

          <div className="summary-divider" />

          <div className="summary-row total">
            <span>Total</span>
            <span>€ {total.toFixed(2)}</span>
          </div>
        </div>

        <Elements
          stripe={stripePromise}
          options={{ clientSecret: state.clientSecret }}
        >
          <EventPaymentForm bookingId={state.bookingId} />
        </Elements>
      </div>
    </div>
  );
}
